export const LOGO_URL = "/ball0ut-logo.png";
export const INSTAGRAM_URL = "https://www.instagram.com/ball0ut.ent";
